export const FILTER_TYPES = {
	MAKE: 'make',
	RADIUS: 'radius'
};
export const DEFAULT_RANGE = 50;
